import React, { useEffect, useState } from "react";
import { getHighlight } from "../Service/Api";
import { Link } from "react-router-dom";

const Highlights = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getHighlight();
        setData(response);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const emptyData = [
    { id: 1, title: "Stay Tuned For More Updates" },
    { id: 2, title: "Stay Tuned For More Updates" },
    { id: 3, title: "Stay Tuned For More Updates" },
  ];

  const S3_BASE_URL =
    "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/";

  if (loading) {
    return (
      <div className="highlights">
        <p>Loading highlights...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="highlights">
        <p>Error loading highlights</p>
      </div>
    );
  }

  return (
    <div className="highlights">
      <marquee
        onMouseOver={(e) => e.currentTarget.stop()}
        onMouseOut={(e) => e.currentTarget.start()}
      >
        {data && data.length > 0
          ? data.map((item, index) => {
            const file = item.attachments?.[0];

            return (
              <p key={index} style={{ display: "inline-block", marginRight: "20px" }}>
                {file ? (
                  <Link
                    to={`${S3_BASE_URL}${file}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.title} <i className="bi bi-paperclip"></i>
                  </Link>
                ) : (
                  <span>{item.title}</span>
                )}
                {" | "}
              </p>
            );
          })
          : emptyData.map((item) => (
            <p key={item.id} style={{ display: "inline-block", marginRight: "20px" }}>
              <Link to="#" onClick={(e) => e.preventDefault()}>
                {item.title} <i className="bi bi-paperclip"></i>
              </Link>{" "}
              |{" "}
            </p>
          ))}
      </marquee>
    </div>
  );
};

export default Highlights;